import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";
import { base_url } from "Backend/api";

const SearchBarSuggest = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
  if (!searchQuery) {
    setResults([]);
    return;
  }

  const timer = setTimeout(async () => {
    try {
      const token = localStorage.getItem("token");

    if (!token) {
      toast.error("يجب تسجيل الدخول أولاً");
      return;
    }
      const res = await fetch(
        `${base_url}/api/restaurants?search=${searchQuery}`,
        {
          method: 'GET',
          headers: {
             Authorization: `Bearer ${token}`,
            'Accept': 'application/json',
          },
        }
      );

      const data = await res.json();

      if (data.status) {
        setResults(data.data || []);
        setShowDropdown(true);
      }
    } catch (err) {
      console.error("search error", err);
    }
  }, 400); // debounce

  return () => clearTimeout(timer);
}, [searchQuery]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!searchQuery.trim()) return;

    navigate(`/restaurants?search=${searchQuery}`);
    setShowDropdown(false);
  };

  const handleSelect = (restaurant) => {
    navigate(`/restaurant/${restaurant.slug || restaurant.id}`);
    setShowDropdown(false);
  };

  return (
    <div className="w-full px-4 mt-0 lg:mt-4 md:mt-2 md:px-6 lg:px-8 mb-2 relative">
      <div className="max-w-4xl mx-auto">

        <form onSubmit={handleSubmit} className="relative w-full">

          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="عما تبحث ؟"
            className="w-full font-[cairo] h-8 md:h-12 bg-white rounded-[30px] px-4 md:px-5 pr-12 md:pr-14 text-sm md:text-base text-foreground placeholder:text-muted-foreground outline-none border-0  focus:ring-2 focus:ring-primary transition-all duration-250"
          />

          <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
            <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
          </div>

        </form>

        {showDropdown && results.length > 0 && (
          <div className="absolute left-0 right-0 mt-2 bg-white shadow-xl rounded-xl overflow-hidden z-50 font-[cairo]">

            {results.slice(0, 5).map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelect(item)}
                className="flex items-center gap-3 p-3 hover:bg-gray-100 cursor-pointer"
              >
                <img
                  src={`${base_url}/storage/app/public/${item.image}`}
                  alt={item.name}
                  className="w-10 h-10 rounded-lg object-cover"
                />

                <div className="flex flex-col">
                  <span className="font-medium text-sm">{item.name}</span>
                  <span className="text-xs text-gray-500">
                    {item.full_address}
                  </span>
                </div>
              </div>
            ))}

          </div>
        )}

      </div>
    </div>
  );
};

export default SearchBarSuggest;